<template>
  <div class="ms-tabs ms-flex-middle">
    <div class="ms-tab-item" :class="{active: index == active}" v-for="(item, index) in tabList" :key="item.id" @click="handleTabClick(index)">{{ item.name }}</div>
  </div>
</template>

<script>
export default {
  name: 'MsTabs',
  props: {
    active: {
      type: Number,
      default: 0
    },
    tabList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleTabClick(index) {
      this.$emit('handle-click', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.ms-tabs {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  .ms-tab-item {
    height: 35px;
    background: #FFFFFF;
    border-radius: 10px 10px 2px 2px;
    border: 1px solid #E7E7E7;
    text-align: center;
    line-height: 35px;
    padding: 0 15px;
    cursor: pointer;
    color: #737373;
    font-size: 15px;
    white-space: nowrap;
    &.active {
      background: #DC3C3C;
      border-color: #DC3C3C;
      color: #fff;
    }
  }
}
</style>